import angular from "angular";
import tagsTemplate from "./tags.template.html";

/*******************************************************************************
 * Component: itemTagsContent
 *
 * This is the component to be used to manage the list of indicator tags for a
 * product in the AddChangeItemDialog. This will utilize the addChangeItemDialog's
 * component controller for shared data management.
 *******************************************************************************/
export const itemTagsContentComponent = {
  require: { dialogCtrl: '^^addChangeItemDialogContent' },
  template: tagsTemplate,
  controller: 'ItemTagsController',
  controllerAs: '$itCtrl'
}

/* @ngInject */ export function ItemTagsController($scope, AddChangeTagDialog, SERVER) {
  /*****************************************************************************
   * Properties
   *****************************************************************************/
  /** Controller Instance. */ var mThis = this;
  /** AddChangeTagDialog shown. */ var mTagDialogActive = false;

  /*-------------------------------------------------*/
  /* Keep track of tags selected tags in the         */
  /* Available Tags and the Current Item Tags lists. */
  /*-------------------------------------------------*/
  mThis.selectedAvailableTag = null;
  mThis.selectedCurrentTag = null;

  /*****************************************************************************
   * Dataproviders
   *****************************************************************************/
  /** Current Product Tags. */ mThis.currentTags = null;
  /** Unassigned Tags. */ mThis.availableTags = null;

  /**************************************************************************
   * addTagHandler */
  /**
   * Fired when the New tag button on the Indicator Tags tab is clicked. Adds
   * a new tag to the list of available tags.
   ***************************************************************************/
  mThis.addTagHandler = function () {
    /*-------------------------------*/
    /* Dialog already active, abort. */
    /*-------------------------------*/
    if (mTagDialogActive) return;

    /*-----------------------------------*/
    /* Display the dialog with indicator */
    /* tag as the only tag type allowed. */
    /*-----------------------------------*/
    mTagDialogActive = true;
    AddChangeTagDialog.show(null, [SERVER.BooksDBConstants.TT_INDICATOR])
      .then(function (tag) {
        /*-----------------------------*/
        /* Add the new Tag to the list */
        /*-----------------------------*/
        mThis.dialogCtrl.tagLists.indicatorTags.push(tag);
        updateTagDisplay();
      })
      ['finally'](function () {
        mTagDialogActive = false;
      });
  };

  /***************************************************************************
   * moveTag */
  /**
   * Click handler for the directional move buttons for moving tags between the
   * available and current lists.
   *
   * @param   direction  Direction to move the item. True=Available to current.
   ***************************************************************************/
  mThis.moveTag = function (direction) {
    /*------------------------------------*/
    /* Ensure array property is available */
    /*------------------------------------*/
    if (!mThis.item.indicatorTags) mThis.item.indicatorTags = [];

    /*-------------------------------------------------------*/
    /* Move selected available tag to the current tags list. */
    /*-------------------------------------------------------*/
    if (direction) {
      if (!mThis.selectedAvailableTag) return;

      mThis.item.indicatorTags.unshift(mThis.selectedAvailableTag);
      mThis.selectedAvailableTag = null;
    } else {
      /*-----------------------------------*/
      /* Remove selected current item tag. */
      /*-----------------------------------*/
      if (!mThis.selectedCurrentTag) return;

      for (var i = 0; i < mThis.item.indicatorTags.length; i++)
        if (mThis.item.indicatorTags[i].id == mThis.selectedCurrentTag.id)
          mThis.item.indicatorTags.splice(i, 1);

      mThis.selectedCurrentTag = null;
    }

    /*---------------------*/
    /* Update for the move */
    /*---------------------*/
    updateTagDisplay();
  };

  /***************************************************************************
   * selectAvailableTag */
  /**
   * Click handler for each tag item in the available tag list on the Indicator
   * Tags tab. Toggles selection on the clicked available tag.
   ***************************************************************************/
  mThis.selectAvailableTag = function (t) {
    if (mThis.selectedAvailableTag == t)
      mThis.selectedAvailableTag = null;
    else mThis.selectedAvailableTag = t;
  };

  /***************************************************************************
   * selectCurrentTag */
  /**
   * Click handler for each tag item in the current tag list on the Indicator
   * Tags tab. Sets the selected current tag, if the tag is already selected,
   * it is deselected.
   ***************************************************************************/
  mThis.selectCurrentTag = function (t) {
    if (mThis.selectedCurrentTag == t) mThis.selectedCurrentTag = null;
    else mThis.selectedCurrentTag = t;
  };

  /***************************************************************************
   * updateTagDisplay */
  /**
   * Refreshes the indicator tags lists.
   ***************************************************************************/
  function updateTagDisplay() {
    /*----------------------------------------------------*/
    /* Set the display property (true/false/null) on each */
    /* tag to be used with the tagIndicator directive to  */
    /* ensure the tags are displayed correctly.           */
    /*----------------------------------------------------*/
    angular.forEach(
      mThis.dialogCtrl.tagLists.indicatorTags,
      function (t) {
        t.display =
          t.showAssigned && t.showNotAssigned
            ? null
            : t.showAssigned
              ? true
              : false;
      }
    );

    /*---------------------------------*/
    /* Set up the current list of tags */
    /* for only the indicator tags.    */
    /*---------------------------------*/
    mThis.currentTags = mThis.dialogCtrl.tagLists.indicatorTags.filter(
      function (t) {
        return (
          !mThis.dialogCtrl.uiFlags.isBaseItem &&
          (mThis.item.indicatorTags || []).some(function (itemTag) {
            return itemTag.id == t.id;
          })
        );
      }
    );

    /*------------------------------------------------------------*/
    /* Set up the available tag list for only the indicator tags. */
    /*------------------------------------------------------------*/
    mThis.availableTags = mThis.dialogCtrl.tagLists.indicatorTags.filter(
      function (t) {
        return (
          !mThis.dialogCtrl.uiFlags.isBaseItem &&
          !(mThis.item.indicatorTags || []).some(function (itemTag) {
            return itemTag.id == t.id;
          })
        );
      }
    );
  }

  /*---------------------------------------------------*/
  /* Set up an accessor the item property from the     */
  /* dialogCtrl. Use an empty object for data binding. */
  /*---------------------------------------------------*/
  Object.defineProperty(mThis, 'item', {
    get: function () {
      return mThis.dialogCtrl ? mThis.dialogCtrl.item : {};
    }
  });

  /*----------------------------------------------------*/
  /* Update the display when the item reference changes */
  /*----------------------------------------------------*/
  $scope.$watch(function () {
    return mThis.item;
  }, updateTagDisplay);
}
